import {createFeatureSelector, createSelector} from '@ngrx/store';
import {studentFeatureKey, StudentState} from "../reducers/student.reducer";

export const selectStudentFeature = createFeatureSelector<StudentState>(
  studentFeatureKey
);

export const getActiveGameCategoryId = () => createSelector(
  selectStudentFeature,
  (state: StudentState) => {
    return state.activeGameCategoryId;
  }
);
export const getActiveSchoolClassIdStudent = () => createSelector(
  selectStudentFeature,
  (state: StudentState) => {
    return state.activeClassId;
  }
);

